/**
 * 以\u180e字符增加积木内部field之间的间距;
 * **/
import Blockly from "blockly";
import {
    BREAK_CONTINUE,
    GTA_CONTROLS_WHILEUNTIL_HELPURL,
    WAITING_TIME
} from "../../../../public/blockly/msg/details/zh-hans-gta.js";

// 控制类别基础积木
Blockly.Blocks["gta_ai_controls_item"] = {
    init: function() {
        this.appendDummyInput().appendField(
            new Blockly.FieldLabelSerializable(""),
            "NAME"
        );
        this.setOutput(true);
        this.setStyle("loop_blocks");
        this.setTooltip("");
        this.setInputsInline(true);
        this.setHelpUrl("");
    }
};

Blockly.Python["gta_ai_controls_item"] = function(block) {
    // TODO: Assemble Python into code variable.
    var code = "...";
    // TODO: Change ORDER_NONE to the correct strength.
    return [code, Blockly.Python.ORDER_NONE];
};

// 控制(逻辑)积木 logic.js
Blockly.Blocks.gta_controls_whileUntil = {
    init: function() {
        this.appendDummyInput().appendField("如果 ");
        this.appendValueInput("NAME1").setCheck("Boolean");
        this.appendDummyInput().appendField(" 重复执行");
        this.appendStatementInput("NAME2").setCheck(null);
        this.setInputsInline(true);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setStyle("loop_blocks");
        // this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl(Blockly.Msg['GTA_CONTROLS_WHILEUNTIL_HELPURL']);
        // this.setHelpUrl("/projects/helpdocument/operators?menu=Control#2");
    }
};
Blockly.Python.gta_controls_whileUntil = function(a) {
    var value_name = Blockly.Python.valueToCode(
        a,
        "NAME1",
        Blockly.Python.ORDER_ATOMIC
    );
    var statements_name = Blockly.Python.statementToCode(a, "NAME2");
    // TODO: Assemble JavaScript into code variable.
    var code = "while " + value_name + ":\n" + statements_name + "\n";
    return code;
};

// break_continue积木;
Blockly.Blocks.break_continue = {
    init: function() {
        this.appendDummyInput().appendField(
            new Blockly.FieldDropdown([
                ["break", "break"],
                ["continue", "continue"]
            ]),
            "FLOW"
        );
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setStyle("logic_blocks");
        this.setTooltip("");
        this.setHelpUrl(Blockly.Msg['BREAK_CONTINUE_HELPURL']);
        // this.setHelpUrl("/projects/helpdocument/operators?menu=Control#5");
    }
};

Blockly.Blocks["controls_if"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
            // message0: "%{BKY_CONTROLS_IF_MSG_IF} %1  ",
            args0: [{
                type: "input_value",
                name: "IF0",
                check: "Boolean"
            }],
            message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            args1: [{
                type: "input_statement",
                name: "DO0"
            }],
            previousStatement: null,
            nextStatement: null,
            style: "logic_blocks",
            inputsInline: true,
            helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
            mutator: "controls_if_mutator",
            extensions: ["controls_if_tooltip"]
        });
    }
};

Blockly.Blocks["controls_repeat_ext"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e %{BKY_CONTROLS_REPEAT_TITLE}\u180e",
            args0: [{
                type: "input_value",
                name: "TIMES",
                check: "Number"
            }],
            message1: " \u180e%{BKY_CONTROLS_REPEAT_INPUT_DO}\u180e%1",
            args1: [{
                type: "input_statement",
                name: "DO"
            }],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
        });
    }
};

Blockly.Blocks["controls_forEach"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_CONTROLS_FOREACH_TITLE}",
            args0: [{
                    type: "field_variable",
                    name: "VAR",
                    variable: null
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO}%1",
            args1: [{
                type: "input_statement",
                name: "DO"
            }],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FOREACH_HELPURL}",
            extensions: [
                "contextMenu_newGetVariableBlock",
                "controls_forEach_tooltip"
            ]
        });
    }
};

// 逻辑非，取反
Blockly.Blocks["logic_negate"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_LOGIC_NEGATE_TITLE}",
            args0: [{
                type: "input_value",
                name: "BOOL",
                check: "Boolean"
            }],
            output: "Boolean",
            style: "logic_blocks",
            inputsInline: true,
            tooltip: "%{BKY_LOGIC_NEGATE_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NEGATE_HELPURL}"
        });
    }
};
// 三元表达式
Blockly.Blocks["logic_ternary"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_LOGIC_TERNARY_CONDITION} %1",
            args0: [{
                type: "input_value",
                name: "IF",
                check: "Boolean"
            }],
            message1: "%{BKY_LOGIC_TERNARY_IF_TRUE} %1",
            args1: [{
                type: "input_value",
                name: "THEN"
            }],
            message2: "%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
            args2: [{
                type: "input_value",
                name: "ELSE"
            }],
            output: null,
            style: "logic_blocks",
            inputsInline: true,
            tooltip: "%{BKY_LOGIC_TERNARY_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_TERNARY_HELPURL}",
            extensions: ["logic_ternary"]
        });
    }
};

// 等待时间
Blockly.Blocks.waiting_time = {
    init: function() {
        this.appendDummyInput()
            .appendField("等待")
            .appendField(new Blockly.FieldNumber(0, 0), "NAME")
            .appendField("s");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setStyle("logic_blocks");
        this.setTooltip("");
        this.setHelpUrl(Blockly.Msg['WAITING_TIME_HELPURL']);
        // this.setHelpUrl("/projects/helpdocument/operators?menu=Control#9");
    }
};

Blockly.Python.waiting_time = function(block) {
    var name = block.getFieldValue("NAME");
    // TODO: Assemble Python into code variable.
    return "GTAFunWait(" + name + ")\n";
    // return "import time\n" + "time.sleep(" + name + ")\n";
};
// 等待时间2
Blockly.Blocks.waiting_time_2 = {
    init: function() {
        this.appendDummyInput()
            .appendField("等待")
            .appendField(new Blockly.FieldNumber(0, 0), "NAME")
            .appendField("s");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setStyle("logic_blocks");
        this.setTooltip("");
        this.setHelpUrl(Blockly.Msg['WAITING_TIME_HELPURL']);
        // this.setHelpUrl("/projects/helpdocument/operators?menu=Control#9");
    }
};

Blockly.Python.waiting_time_2 = function(block) {
    let time = block.getFieldValue("NAME");
    // TODO: Assemble Python into code variable.
    return "import time;\ntime.sleep(" + time + ")\n";
    // return "import time\n" + "time.sleep(" + name + ")\n";
};

// 等待时间
Blockly.Blocks.time_sleep = {
    init: function() {
        this.appendDummyInput()
            .appendField("持续")
            .appendField(new Blockly.FieldNumber(0, 0), "NAME")
            .appendField("s");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setStyle("event_blocks");
        this.setTooltip("");
        this.setHelpUrl("");
    }
};

Blockly.Python.time_sleep = function(block) {
    var name = block.getFieldValue("NAME");
    // TODO: Assemble Python into code variable.
    return "time.sleep(" + name + ")\n";
    // return "import time\n" + "time.sleep(" + name + ")\n";
};


Blockly.Python.break_continue = function(block) {
    var dropdown_flow = block.getFieldValue("FLOW");

    return dropdown_flow + "\n";
};
